// test1043
(1043 && 0);
